function fetchScript(url, params) {
  var query = new URLSearchParams(params).toString();
  var separator = url.indexOf('?') === -1 ? '?' : '&';
  fetch(url + separator + query, {
    headers: {
      'Accept': 'text/javascript, application/javascript, */*; q=0.01',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin'
  }).then(function(res) {
    return Promise.all([res, res.text()]);
  }).then(function(result) {
    var res = result[0];
    var js = result[1];
    var contentType = (res.headers.get('content-type') || '').toLowerCase();
    if (!res.ok || contentType.indexOf('javascript') === -1) {
      throw new Error('Expected JavaScript from ' + res.url + ' but received ' + (contentType || 'unknown content type'));
    }
    var script = document.createElement('script');
    script.textContent = js;
    document.head.appendChild(script);
    document.head.removeChild(script);
  }).catch(function(error) {
    console.error(error);
  });
}

var expand_deck = function(deckId) {
  var tr = document.querySelector(".tournament-decklist[data-deckid='" + deckId + "']");
  if (!tr) return;
  tr.style.display = tr.style.display === 'none' ? '' : 'none';
  toggle_deck_update(deckId);
}

window.expand_deck = expand_deck;

var toggle_deck_update = function(deckId) {
  var tr = document.querySelector(".tournament-decklist[data-deckid='" + deckId + "']");
  if (!tr) return;
  var toggleLink = document.querySelector(".tournament-decklist-toggle[data-deckid='" + deckId + "'] a");
  if (toggleLink) {
    toggleLink.textContent = tr.style.display !== 'none' ? "Collapse" : "Expand";
  }

  if (!tr.dataset.loaded) {
    tr.dataset.loaded = 'true';
    fetchScript("/widgets/deck/js", { deckId: deckId });
  }
}

const getParameterByName = (name) => {
    var query = window.location.search.toString();
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(query);
    if (results == null) return "";
    else return decodeURIComponent(results[1].replace(/\+/g, " "));
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll(".widget-deck-placeholder").forEach(function(el) {
    var params = el.dataset.params;
    var url = "/widgets/deck/js";
    var domId = el.getAttribute('id');

    var utmSource = getParameterByName('utm_source');
    var utmMedium = getParameterByName('utm_medium');
    var utmContent = getParameterByName('utm_content');
    var utmCampaign = getParameterByName('utm_campaign');

    url += "?utm_source=" + utmSource;
    url += "&utm_medium=" + utmMedium;
    url += "&utm_content=" + utmContent;

    if (typeof $utm_campaign !== 'undefined') {
      url += "&utm_campaign=" + $utm_campaign;
    } else if (utmCampaign) {
      url += "&utm_campaign=" + utmCampaign;
    }

    if (typeof params !== 'undefined') {
      url += "&" + params;
    }

    var fetchParams = { domId: domId };
    if (el.dataset.id) fetchParams.deckId = el.dataset.id;
    fetchScript(url, fetchParams);
  });
  window.MTGGoldfish_DeckWidget = true;
});

document.addEventListener('click', function(e) {
  if (!e.target || !e.target.closest('.tournament-decklist-collapse')) return;
  var btn = e.target.closest('.tournament-decklist-collapse');
  var newOption, newValue;
  if (btn.textContent.trim() === "Collapse Decks") {
    newOption = "Expand Decks";
    newValue = false;
  } else {
    newOption = "Collapse Decks";
    newValue = true;
  }
  document.querySelectorAll('.tournament-decklist-collapse').forEach(function(el) {
    el.textContent = newOption;
  });
  document.querySelectorAll(".tournament-decklist").forEach(function(el) {
    el.style.display = newValue ? '' : 'none';
    toggle_deck_update(el.dataset.deckid);
  });
});
